import { createFileRoute } from "@tanstack/react-router"
import Delivery from "@/app/settings/club/equipments/delivery/page"

export const Route = createFileRoute("/settings/club/equipments/delivery")({
  component: Delivery,
})
